// @ts-nocheck
/* eslint-disable */

import React from 'react';
import AddEntity from '../../components/CRUD/AddEntity';

const AddFareMediaBatch = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  const inputs = [
    {
      name: 'label',
      labelKey: 'BatchLabel',
      type: 'text',
      required: true,
      defaultValue: ''
    },
    {
      name: 'note',
      labelKey: 'Notes',
      type: 'text',
      required: false,
      defaultValue: ''
    }
  ];

  const dropdowns = [
    {
      name: 'organisations_id',
      labelKey: 'Organisation',
      required: true,
      apiUrl: `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/faremedia/get_organisations`,
      apiMethod: 'GET',
      dataPath: 'data.data',
      optionConfig: {
        valueKey: 'id',
        labelKey: 'en_name',
        labelKeyAr: 'ar_name'
      }
    }
  ];

  return (
    <AddEntity
      // ============ PAGE CONFIGURATION ============
      pageTitle="AddNewFareMediaBatch"
      backUrl="/CardsManagement/fare-media-batches"

      // ============ API CONFIGURATION ============
      submitApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/fare_media_batches`}

      // ============ FORM CONFIGURATION ============
      inputs={inputs}
      dropdowns={dropdowns}

      // ============ SUCCESS CONFIGURATION ============
      successMessage="FareMediaBatchCreatedSuccessfully"

      // ============ PERMISSIONS ============
      subsystemName="FareMediaBatches"
      permissionSystem="masterConfig"
    />
  );
};

export default AddFareMediaBatch;
